/* Next10 - calculadora de frete por CEP.
   Usa as transportadoras configuradas na loja (/cart/shipping_rates.json).
   Na PDP o produto entra no carrinho por um instante para a consulta
   e o carrinho volta exatamente ao estado anterior. */
(function () {
  if (window.__n10Frete) return;
  window.__n10Frete = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MOEDA = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
  var STORE_KEY = 'n10_cep';

  /* Faixas de CEP por estado, em 8 DÍGITOS (é o que parseInt de um CEP devolve:
     "88040-432" → 88040432). A tabela anterior estava em 7 dígitos, então nenhum
     CEP real caía em faixa nenhuma, o estado ia vazio e a Shopify respondia
     422 {"province":["Selecione um estado"]} — a calculadora falhava sempre. */
  var FAIXAS = [
    [1000000, 19999999, 'SP'], [20000000, 28999999, 'RJ'], [29000000, 29999999, 'ES'],
    [30000000, 39999999, 'MG'], [40000000, 48999999, 'BA'], [49000000, 49999999, 'SE'],
    [50000000, 56999999, 'PE'], [57000000, 57999999, 'AL'], [58000000, 58999999, 'PB'],
    [59000000, 59999999, 'RN'], [60000000, 63999999, 'CE'], [64000000, 64999999, 'PI'],
    [65000000, 65999999, 'MA'], [66000000, 68899999, 'PA'], [68900000, 68999999, 'AP'],
    [69000000, 69299999, 'AM'], [69300000, 69399999, 'RR'], [69400000, 69899999, 'AM'],
    [69900000, 69999999, 'AC'], [70000000, 72799999, 'DF'], [72800000, 72999999, 'GO'],
    [73000000, 73699999, 'DF'], [73700000, 76799999, 'GO'], [76800000, 76999999, 'RO'],
    [77000000, 77999999, 'TO'], [78000000, 78999999, 'MT'], [79000000, 79999999, 'MS'],
    [80000000, 87999999, 'PR'], [88000000, 89999999, 'SC'], [90000000, 99999999, 'RS']
  ];

  function ufDoCep(cep) {
    var n = parseInt(cep, 10);
    if (isNaN(n)) return '';
    for (var i = 0; i < FAIXAS.length; i++) {
      if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return '';
  }

  function soDigitos(v) { return (v || '').replace(/\D/g, '').slice(0, 8); }

  function mascara(v) {
    var d = soDigitos(v);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function dinheiro(valor) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: MOEDA }).format(valor);
    } catch (e) {
      return 'R$ ' + valor.toFixed(2).replace('.', ',');
    }
  }

  function dataCurta(txt) {
    if (!txt) return '';
    var m = String(txt).match(/(\d{4})-(\d{2})-(\d{2})/);
    return m ? m[3] + '/' + m[2] : '';
  }

  function prazoTexto(rate) {
    var faixa = rate.delivery_range || [];
    var ini = dataCurta(faixa[0]);
    var fim = dataCurta(faixa[1]);
    if (ini && fim && ini !== fim) return 'Chega entre ' + ini + ' e ' + fim;
    if (ini) return 'Chega em ' + ini;
    if (rate.delivery_days && rate.delivery_days.length) {
      var d = rate.delivery_days;
      var a = d[0], b = d[d.length - 1];
      return a === b ? 'Em até ' + a + ' dia(s) úteis' : 'Em ' + a + ' a ' + b + ' dias úteis';
    }
    return '';
  }

  function json(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  }

  function buscarTaxas(cep, uf) {
    var q = 'shipping_address[zip]=' + encodeURIComponent(cep) +
      '&shipping_address[country]=' + encodeURIComponent('Brazil') +
      (uf ? '&shipping_address[province]=' + encodeURIComponent(uf) : '');
    return json(ROOT + 'cart/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.data && res.data.message;
          throw new Error(msg || 'Não foi possível calcular agora. Tente de novo.');
        }
        return (res.data && res.data.shipping_rates) || [];
      });
  }

  function pegarCarrinho() {
    return json(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.data || { items: [] }; });
  }

  function mudarLinha(key, quantidade) {
    return json(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantidade })
    });
  }

  function restaurar(variantId, anterior) {
    return pegarCarrinho().then(function (cart) {
      var alvo = null;
      (cart.items || []).forEach(function (item) {
        if (!alvo && String(item.variant_id) === String(variantId)) alvo = item;
      });
      if (!alvo || alvo.quantity === anterior) return null;
      return mudarLinha(alvo.key, anterior);
    }).catch(function () { return null; });
  }

  function taxasDoProduto(cep, uf, variantId, qtd) {
    var anterior = 0;
    return pegarCarrinho()
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) anterior += item.quantity;
        });
        return json(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qtd }] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Produto indisponível para calcular o frete.');
        return buscarTaxas(cep, uf);
      })
      .then(function (taxas) {
        return restaurar(variantId, anterior).then(function () { return taxas; });
      })
      .catch(function (err) {
        return restaurar(variantId, anterior).then(function () { throw err; });
      });
  }

  function contexto(box) {
    return box.getAttribute('data-context') === 'cart' ? 'cart' : 'product';
  }

  function varianteAtual(box) {
    var input = document.querySelector('product-form form[data-type="add-to-cart-form"] [name="id"]');
    if (input && input.value) return input.value;
    return box.getAttribute('data-variant') || '';
  }

  function quantidadeAtual() {
    var input = document.querySelector('product-form form[data-type="add-to-cart-form"] [name="quantity"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function render(box, html) {
    var out = box.querySelector('[data-n10-frete-out]');
    if (!out) return;
    out.innerHTML = html;
    out.hidden = !html;
  }

  function erro(box, texto) {
    render(box, '<p class="n10-frete__msg n10-frete__msg--erro">' + texto + '</p>');
  }

  function escapar(txt) {
    return String(txt == null ? '' : txt)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* A entrega local da Shopify volta sempre como "Local Delivery" (o nome da zona
     não vem na API); o rótulo em português sai do snippet (data-local-label). */
  function nomeTaxa(box, rate) {
    var local = box.getAttribute('data-local-label');
    if (local && rate.source === 'shopify' && rate.code === 'Local Delivery') return local;
    return rate.name || 'Entrega';
  }

  function listar(box, taxas, cep, uf) {
    if (!taxas.length) {
      erro(box, 'Nenhuma opção de entrega para esse CEP. Fale com a gente que a gente dá um jeito.');
      return;
    }
    var html = '<p class="n10-frete__local">Entrega para ' + mascara(cep) + (uf ? ' · ' + uf : '') +
      '</p><ul class="n10-frete__lista">';
    taxas.forEach(function (rate) {
      var valor = parseFloat(rate.price);
      if (isNaN(valor)) valor = 0;
      var gratis = valor <= 0;
      var prazo = prazoTexto(rate);
      /* "Informações de entrega" da zona (Admin → Envio e entrega) — antes só apareciam no checkout. */
      var info = String(rate.description || '').trim();
      html += '<li class="n10-frete__opcao"><span class="n10-frete__nome">' + escapar(nomeTaxa(box, rate)) +
        (prazo ? '<span class="n10-frete__prazo">' + prazo + '</span>' : '') +
        (info ? '<span class="n10-frete__info">' + escapar(info) + '</span>' : '') +
        '</span><span class="n10-frete__preco' + (gratis ? ' n10-frete__preco--gratis' : '') + '">' +
        (gratis ? 'Grátis' : dinheiro(valor)) + '</span></li>';
    });
    html += '</ul>';
    render(box, html);
  }

  function calcular(box) {
    var input = box.querySelector('[data-n10-frete-cep]');
    var btn = box.querySelector('[data-n10-frete-go]');
    if (!input) return;

    var cep = soDigitos(input.value);
    if (cep.length !== 8) {
      erro(box, 'Digite um CEP válido, com 8 números.');
      input.focus();
      return;
    }

    try { localStorage.setItem(STORE_KEY, cep); } catch (e) {}

    var uf = ufDoCep(cep);
    if (btn) btn.disabled = true;
    render(box, '<p class="n10-frete__msg">Calculando...</p>');

    var promessa;
    if (contexto(box) === 'cart') {
      promessa = buscarTaxas(cep, uf);
    } else {
      var variante = varianteAtual(box);
      if (!variante) {
        erro(box, 'Escolha uma opção do produto antes de calcular.');
        if (btn) btn.disabled = false;
        return;
      }
      promessa = taxasDoProduto(cep, uf, variante, quantidadeAtual());
    }

    promessa
      .then(function (taxas) { listar(box, taxas, cep, uf); })
      .catch(function (e) { erro(box, (e && e.message) || 'Não foi possível calcular agora. Tente de novo.'); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-n10-frete-go]') : null;
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-n10-frete]');
    if (box) calcular(box);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest ? e.target.closest('[data-n10-frete-cep]') : null;
    if (!input) return;
    e.preventDefault();
    var box = input.closest('[data-n10-frete]');
    if (box) calcular(box);
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest ? e.target.closest('[data-n10-frete-cep]') : null;
    if (!input) return;
    input.value = mascara(input.value);
  });

  function preencherSalvo(escopo) {
    var salvo = '';
    try { salvo = localStorage.getItem(STORE_KEY) || ''; } catch (e) {}
    if (!salvo) return;
    var campos = (escopo || document).querySelectorAll('[data-n10-frete-cep]');
    Array.prototype.forEach.call(campos, function (input) {
      if (!input.value) input.value = mascara(salvo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { preencherSalvo(); });
  } else {
    preencherSalvo();
  }

  document.addEventListener('cart:refresh', function () { setTimeout(preencherSalvo, 30); });
  document.addEventListener('shopify:section:load', function (e) { preencherSalvo(e.target); });
})();
